import { ConversationItem } from '@app/models'

import { mergeMapByKey } from '@lib/utils'

import { CONVERSATIONS_LIST_SIZE } from '../constants'
import { ChatState, ListChunkPayload } from '../types'

export const onFetchListChunkSuccess = (
  state: ChatState,
  payload: ListChunkPayload
): ChatState => {
  const listings = mergeMapByKey(payload.listings, state.listings, 'id')
  const accounts = mergeMapByKey(payload.accounts, state.accounts, 'id')

  const conversations = payload.conversations.reduce<
    Record<number, ConversationItem>
  >((acc, item) => {
    if (
      state.conversations[item.id] &&
      state.conversations[item.id].fetching === 'SUCCEED'
    ) {
      return acc
    }

    return {
      ...acc,
      [item.id]: item,
    }
  }, state.conversations)

  const nextPageCursor = payload.nextPageCursor
  const allConversationsLoaded =
    payload.conversations.length < CONVERSATIONS_LIST_SIZE

  return {
    ...state,

    conversations,
    listings,
    accounts,
    nextPageCursor,
    allConversationsLoaded,
    fetchingListChunk: 'SUCCEED',
  }
}
